import React from 'react'
import './Home.css'
import banner_1 from './img/banner_1.jfif'
import banner_2 from './img/banner_2.jpg'
// import product_1 from './img/product_1.jfif'
// import product_2 from './img/product_2.png'
import product_3 from './img/product_3.jpg'
import product_4 from './img/product_4.jpg'
import product_5 from './img/product_5.jpg'
import product_6 from './img/product_6.jpg'
import product_7 from './img/product_7.jpg'

import Product from './Product'

function Home() {
    
    return (
        <div className="home">
            <div className="home_container">
                <img className="home_image" src={banner_1} alt="" />

                <div className="home_row">
                    <Product id={1} title="HP Chromebook x360 14-inch (35.56 cms) Thin & Light Touchscreen Laptop (AMD 3015CE/4GB/64GB eMMC Storage/Chrome OS/Mineral Silver/1.49 kg), 14a-cb0007AU"
                    price={48500} image={product_7} rating={3}/>
                   
                    <Product id={2} title="Apple MacBook Pro (16-inch/41.05 cm, Apple M1 Pro chip with 10‑core CPU and 16‑core GPU, 16GB RAM, 1TB SSD) - Space Grey"
                    price={88000} image={product_6} rating={2}/>
                   
                </div>
                <div className="home_row">
                <Product id={3} title="Echo Dot (3rd Gen, Black) + Wipro 9W LED Smart Color Bulb combo - Works with Alexa - Smart Home starter kit Brand: Amazon"
                    price={9500} image={product_3} rating={1}/>
                <Product id={4} title="boAt Airdopes 441 TWS Ear-Buds with IWP Technology, Immersiv"
                    price={1250} image={product_4} rating={3}/>
                <Product id={5} title="OnePlus 9R 5G (Lake Blue, 8GB RAM, 128GB Storage)"
                    price={36000} image={product_5} rating={2}/>
                
                    
                </div>
                <div className="home_row">
                <Product id={6} title="boAt Rockerz 255 Pro+ in-Ear Earphones with 40 Hours Battery"
                    price={152015} image={banner_2} rating={2}/>

                </div>
            </div>
        </div>
    )
}

export default Home
